/** Icon and colour keys the data may reference. The UI draws them (src/ui/icons.ts); a unit test keeps both lists equal. */
export const ICON_KEYS = ["link","sheet","note","clipboard","calculator","chart","folder","calendar","mail","chat","video","globe",
  "briefcase","user","users","home","wallet","cart","heart","pulse","book","bulb","star","sparkles",
  "code","key","pin","coffee","music","camera","grid"] as const;
export const COLOR_KEYS = ["violet","green","sky","amber","orange","rose","pink","slate"] as const;

export const isIcon = (v: unknown): v is string => typeof v === "string" && (ICON_KEYS as readonly string[]).includes(v);
export const isColor = (v: unknown): v is string => typeof v === "string" && (COLOR_KEYS as readonly string[]).includes(v);
